export default [{
  path: '/saneamento-voc',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'Saneamento do VOC Historico',
      path: 'historico',
      component: () => import('@/views/saneamentoVoc/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'Saneamento do VOC' }
        ]
      }
    },
    {
      name: 'Saneamento do VOC Editar',
      path: 'edit/:id',
      component: () => import('@/views/saneamentoVoc/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Saneamento do VOC', path: '/saneamento-voc/historico' },
          { name: 'Editar' }
        ]
      },
    },
    {
      name: 'Saneamento do VOC Adicionar',
      path: 'edit',
      component: () => import('@/views/saneamentoVoc/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Saneamento do VOC', path: '/saneamento-voc/historico' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'Analíticos de CA Histórico',
      path: 'analiticos-ca/historico/:id',
      component: () => import('@/views/saneamentoVoc/analiticosCa/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Saneamento do VOC', path: '/saneamento-voc/historico' },
          { name: 'Analíticos de CA'},
          { name: 'Histórico' }
        ]
      }
    },
    {
      name: 'Analíticos de CA Adicionar',
      path: 'analiticos-ca/add/:id',
      component: () => import('@/views/saneamentoVoc/analiticosCa/Add.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'Saneamento do VOC', path: '/saneamento-voc/historico' },
          { name: 'Analíticos de CA' },
          { name: 'Adicionar' }
        ]
      }
    }
  ]
}]